import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  ApplicationInsights,
  IApplicationInsights,
  IEventTelemetry,
} from '@microsoft/applicationinsights-web';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { RoughagePlusEnvironment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  private readonly title = inject(Title);
  private readonly router = inject(Router);
  private readonly environment =
    inject<RoughagePlusEnvironment>(EnvironmentInjector);

  private readonly appInsights: IApplicationInsights | null = null;

  constructor() {
    if (
      this.environment.ENABLE_TELEMETRY &&
      this.environment.APP_INSIGHTS_KEY
    ) {
      const init = new ApplicationInsights({
        config: {
          instrumentationKey: this.environment.APP_INSIGHTS_KEY,
          disableExceptionTracking: true,
          disablePageShowEvents: [],
        },
      });
      this.appInsights = init.loadAppInsights();
    }
  }

  trackPageView() {
    if (this.appInsights) {
      const uri = this.router.url;
      const properties = {
        uri,
        name: this.title.getTitle(),
        properties: {
          platform: 'browser',
          url: uri,
        },
      };
      this.appInsights.trackPageView(properties);
    }
  }

  trackEvent(name: string, properties: IEventTelemetry['properties'] = {}) {
    if (this.appInsights) {
      this.appInsights.trackEvent({
        name,
        properties: {
          platform: 'browser',
          ...properties,
        },
      });
    }
  }
}
